import { makeUnitsRepository } from 'shared/infra/repositories';

import FetchUnitByIdUseCase from './implementations/FetchUnitByIdUseCase';
import { TLocale } from '../valueObjects';

let instance: FetchUnitByIdUseCase | null;

interface IParams {
  language?: TLocale;
}

export default function makeFetchUnitByIdUseCase(params: IParams) {
  if (!instance) {
    const repository = makeUnitsRepository(params);

    instance = new FetchUnitByIdUseCase(repository);
  }

  return instance;
}
